/* eslint-env browser */

import SharedData, { load } from 'shared/gameData';
import Droptimizer from 'shared/droptimizer';

export default async () => {
  await Promise.all([
    load('EncounterItems'),
    load('Instances'),
  ]);

  Droptimizer.loadStaticData({
    EncounterItems: SharedData.EncounterItems,
    Instances: SharedData.Instances,
  });
};
